const state = {
  isVerified: true,
}

export const mutationTypes = {
  athleteIsVerified:
    '[toggle athlete verified] verified toggle athlete verified',
  athleteNotVerified:
    '[toggle athlete verified] not verified toggle athlete verified',
  athleteClearVerified:
    '[toggle athlete verified] clear verified toggle athlete verified',
}

const mutations = {
  [mutationTypes.athleteIsVerified](state) {
    state.isVerified = true
  },

  [mutationTypes.athleteNotVerified](state) {
    state.isVerified = false
  },

  [mutationTypes.athleteClearVerified](state) {
    state.isVerified = null
  },
}

export default {
  state,
  mutations,
}
